import * as ACTIONS from 'constant/action/webpage'
import * as TABLE from 'constant/table'
import * as LOADER_ACTIONS from 'constant/action/loader'
import * as PAGINATION from 'constant/pagination'
import * as NUMBER from 'constant/number'
import buildFileMeta from 'helper/build-file-meta'
import buildImageFile from 'helper/build-image-file'
import { createAction } from 'redux-actions'
import _ from 'lodash'
import isDraft from 'helper/is-draft'
import isPublished from 'helper/is-published'

const updateWebpages = createAction(ACTIONS.UPDATE_WEBPAGES)
const updateLoading = createAction(LOADER_ACTIONS.UPDATE_LOADING)
const updateWebpageSearchTerm = createAction(ACTIONS.UPDATE_WEBPAGE_SEARCH_TERM)
const updatePagination = createAction(ACTIONS.UPDATE_WEBPAGE_PAGINATION)
const updateWebpageSubmitting = createAction(LOADER_ACTIONS.UPDATE_WEBPAGE_SUBMITTING)

export const getWebpages = (sort = PAGINATION.SORT.WEBPAGE, direction = PAGINATION.DESCENDING, start = NUMBER.ZERO) => async (dispatch, getState, { webpage }) => {
  dispatch(updateLoading(true))
  dispatch(updatePagination({
    direction,
    sort,
    start
  }))
  const {
    webpage: webpageState
  } = getState()

  const webpages = await webpage.getWebpages(sort, direction, TABLE.PAGE_SIZE, _.isNumber(start) ? start : _.get(webpageState, 'webpage.start'))
  dispatch(updateWebpages(webpages))
  dispatch(updateLoading(false))
}

export const searchWebpages = (searchTerm, sort = PAGINATION.SORT.WEBPAGE, direction = PAGINATION.DESCENDING, start = NUMBER.ZERO) => async (dispatch, getState, { webpage }) => {
  dispatch(updateWebpageSearchTerm(searchTerm))

  if (!searchTerm) {
    return dispatch(getWebpages())
  }

  dispatch(updateLoading(true))
  const {
    webpage: webpageState
  } = getState()

  const webpages = await webpage.searchWebpages(searchTerm, sort, direction, TABLE.PAGE_SIZE, _.isNumber(start) ? start : _.get(webpageState, 'webpage.start'))

  dispatch(updateWebpages(webpages))
  dispatch(updateLoading(false))
}

export const addNewWebpage = (webpageObject) => async (dispatch, getState, { webpage }) => {
  const {
    auth: {
      user: { uuid }
    }
  } = getState()
  dispatch(updateWebpageSubmitting(true))
  dispatch(updateLoading(true))

  webpageObject.image_meta = buildImageFile(webpageObject.image_meta)

  const {
    file: imageFile,
    meta: imageMeta
  } = buildFileMeta(webpageObject.image_meta, webpageObject.title)

  const webpageIsDraft = isDraft(webpageObject)
  const newWebpage = {
    ...webpageObject,
    image_meta: imageMeta,
    is_draft: webpageIsDraft,
    published: isPublished(webpageIsDraft, webpageObject.published),
    send_emails: webpageObject.send_emails === 'true',
    type: 'webpage',
    user_uuid: uuid
  }
  const response = await webpage.addNewWebpage(newWebpage)
  if (imageFile) {
    await webpage.uploadFile(response.image_url, imageFile)
  }
  dispatch(getWebpages())
  dispatch(updateWebpageSubmitting(false))
  return newWebpage
}

export const deleteWebpage = (uuid) => async (dispatch, getState, { article }) => {
  await article.deleteArticle(uuid, 'webpage')
  dispatch(getWebpages())
}

export const publishWebpage = (uuid) => async (dispatch, getState, { article }) => {
  await article.publishArticle(uuid)
  dispatch(getWebpages())
}

export const pinWebpage = (uuid) => async (dispatch, getState, { article }) => {
  await article.pinArticle(uuid)

  dispatch(getWebpages())
}

export const editWebpage = (webpageObject) => async (dispatch, getState, { webpage }) => {
  try {
    dispatch(updateWebpageSubmitting(true))
    webpageObject.image_meta = buildImageFile(webpageObject.image_meta)

    const {
      file: imageFile,
      meta: imageMeta
    } = buildFileMeta(webpageObject.image_meta, webpageObject.title)

    const webpageIsDraft = isDraft(webpageObject)
    const editedWebpage = {
      ...webpageObject,
      image_meta: imageMeta,
      is_draft: webpageIsDraft,
      published: isPublished(webpageIsDraft, webpageObject.published),
      send_emails: webpageObject.send_emails === 'true'
    }
    const response = await webpage.editWebpage(editedWebpage)
    if (imageFile) {
      await webpage.uploadFile(response.image_url, imageFile)
    }

    dispatch(updateWebpageSubmitting(false))
    dispatch(getWebpages())
    return { is_draft: webpageObject.is_draft, title: webpageObject.title }
  } catch (error) {
    console.error(error)
    return { error: true, message: error.message }
  }
}

export const downloadWebpages = () => async (dispatch, getState, { webpage }) => {
  try {
    const {
      table: {
        columns: {
          WEBPAGE: columns
        }
      }
    } = getState()
    const { objUrl } = await webpage.downloadWebpages(columns)
    window.open(objUrl)
  } catch (error) {
    console.error(error)
  }
}
